import { useState, useCallback, useRef, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AgGridColumn, AgGridReact } from "ag-grid-react";
import { ColumnApi, GridApi, GridReadyEvent } from "ag-grid-community";
import { Pagination } from "@material-ui/lab";
import { Button, IconButton, Tooltip, useMediaQuery } from "@material-ui/core";

import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import getLimit from "../../../../../../utils/pagination/getLimit";
import initCapitalize from "../../../../../../utils/commonFunctions/initCapitalize";
import { dateTimeZoneConverter } from "../../../../../shared/cellRenderer/cellRenderers";
import getAgGridHeight from "../../../../../../utils/commonFunctions/getAgGridHeight";
import { handleValueCellRenderer } from "../../../../../../utils/commonFunctions/cellRenderers";
import { CustomFilter, CustomFloatingFilter, CustomPagination } from "../../../../../shared";
import { PaginationTypes } from "../../../../../../@types/pagination.types";
import { trackPromise } from "react-promise-tracker";
import { api } from "../../../../../../utils/api";

const GroupOwnersGrid = () => {
	const navigate = useNavigate();
	const [groupOwners, setGroupOwners] = useState([]);
	const [gridHeight, setGridHeight] = useState("400px");
	const [customersFilterSchema, setcustomersFilterSchema] = useState({
		first_name: { value: null, type: null },
		last_name: { value: null, type: null },
		date_of_birth: { value: null, type: null },
		ssn: { value: null, type: null },
		role: { value: null, type: null },
		group_name: { value: null, type: null },
		group_number: { value: null, type: null },
		location: { value: null, type: null }
	});
	const [agGridAPI, setAgGridAPI] = useState<GridApi | null>(null);
	// eslint-disable-next-line no-unused-vars
	const [agGridColumnAPI, setAgGridColumnAPI] = useState<ColumnApi | null>(null);
	const agGridRef = useRef<any>(null);
	const [limit, setLimit] = useState<number | null>(null);
	const [pagination, setPagination] = useState<PaginationTypes>({
		currentPage: 1,
		pageCount: undefined
	});
	const { currentPage, pageCount } = pagination;
	const xl = useMediaQuery("(min-width:1600px)");
	const lg = useMediaQuery("(min-width:1200px)");
	const md = useMediaQuery("(min-width:800px)");
	const sm = useMediaQuery("(min-width:600px)");
	const xs = useMediaQuery("(min-width:400px)");
	const _limit = getLimit(xl, lg, md, sm, xs);

	const handleAgGridReady = (params: GridReadyEvent) => {
		// eslint-disable-next-line no-unused-vars
		const { api, columnApi } = params;
		setAgGridAPI(Object.assign({}, agGridAPI, api));
		setAgGridColumnAPI(columnApi);
	};

	const handleFirstDataRendered = (params: any) => {
		params.api.sizeColumnsToFit();
		params.columnApi.setColumnWidth("action", "100%", true);
		const { api, columnApi } = params;
		api.sizeColumnsToFit();
	};

	const handleViewcustomersDetails = () => {
		const focusedCell = agGridRef.current.api.getFocusedCell();
		const row = agGridRef.current.api.getDisplayedRowAtIndex(focusedCell.rowIndex);
		// console.log("Row", row);
		const { data } = row;
		console.log("========>row", row.data);
		navigate(`/settings/group-permission?qs=${data._id}`);
		// if (role === ROLES.employee) navigate(`/employer/customer?gn=${group_number}&&qs=${encryption(SSN) as string}`);
		// else if (role === ROLES.dependent)
		// 	navigate(`/employer/customer/dependent?gn=${group_number}&&qs=${encryption(SSN) as string}`);
	};

	const handleDetailsChangeRender = () => {
		console.log("");
		return (
			<Button
				className="ag-grid-cell-button"
				variant="outlined"
				onClick={handleViewcustomersDetails}
				style={{ marginTop: "3px", marginBottom: "6px" }}
			>
				See Details
			</Button>
		);
	};

	const handleGetGroupOwnerData = useCallback(async () => {
		const resposnse = await trackPromise(api.groupOwner.getGroupOwnerList({}));
		if (resposnse) {
			setGroupOwners(resposnse);
		}
	}, []);

	const handlePageChange = useCallback(
		(event: React.ChangeEvent<unknown>, page: number) => {
			setPagination(
				Object.assign({}, pagination, {
					currentPage: page
				})
			);
		},
		[pagination]
	);

	// const getcustomers = useCallback(async () => {
	// 	if (typeof limit === "number" && typeof pagination.currentPage === "number") {
	// 		let paginationQuery: PaginationQuery = {
	// 			limit: limit,
	// 			page: pagination.currentPage
	// 		};
	// 		Object.entries(customersFilterSchema).map(([key, value]) => {
	// 			if (value.value !== "" && value.value !== null) {
	// 				paginationQuery = {
	// 					...paginationQuery,
	// 					[key]: value.value
	// 				};
	// 			}
	// 		});
	// 		//console.log(paginationQuery);
	// 		const assignedPaginatedcustomers: AssignedPaginatedcustomers = await api.user.getAssignedPaginatedcustomers(
	// 			paginationQuery
	// 		);
	// 		setCustomers(Object.assign([], assignedPaginatedcustomers.customers));
	// 	}
	// const paginationQuery: PaginationQuery = {
	// 	limit: 30000,
	// 	page: 1
	// };
	// const assignedPaginatedcustomers: AssignedPaginatedcustomers = await trackPromise(
	// 	api.user.getAssignedPaginatedcustomers(paginationQuery)
	// );
	// setCustomers(Object.assign([], assignedPaginatedcustomers.customers));
	// }, [limit, pagination.currentPage, customersFilterSchema]);

	const handleDateCellRenderer = ({ value }: { value: string }) => dateTimeZoneConverter(value);

	const handleUserRoleCellRenderer = ({ value }: { value: string }) => {
		const role = initCapitalize(value);
		return <div>{role}</div>;
	};

	const handleRegisteredcustomerCellRenderer = ({ value }: { value: boolean }) => {
		return <div>{value ? "Yes" : "No"}</div>;
	};

	// const getcustomersCount = useCallback(async () => {
	// 	if (limit) {
	// 		const customerCount = await api.user.getcustomerCount();
	// 		const pageCount = Math.ceil(customerCount / limit);
	// 		console.log("pageCount", pageCount);
	// 		setPagination(Object.assign({}, pagination, { pageCount }));
	// 	}
	// 	// eslint-disable-next-line react-hooks/exhaustive-deps
	// }, [limit]);

	// useEffect(() => {
	// 	if (limit && pagination.pageCount) {
	// 		getcustomers();
	// 	}
	// }, [pagination, limit, getcustomers]);

	// useEffect(() => {
	// 	getcustomers();
	// 	setDashboardHeader(ADMIN_DASHBOARD_HEADER.all_group_customers);
	// }, [getcustomers, setDashboardHeader]);

	useEffect(() => {
		const _gridHeight = getAgGridHeight(groupOwners.length);
		setGridHeight(_gridHeight);
	}, [groupOwners.length]);

	useEffect(() => {
		handleGetGroupOwnerData();
	}, [handleGetGroupOwnerData]);

	// console.log("limit", limit);
	// console.log("pagination", pagination);

	return (
		<div className="employee-dependent-container">
			<div className="employee-dependent-grid-container">
				<div className="ag-theme-alpine" style={{ height: gridHeight, width: "100%" }}>
					<AgGridReact
						ref={agGridRef}
						rowData={groupOwners}
						onGridReady={handleAgGridReady}
						onFirstDataRendered={handleFirstDataRendered}
						animateRows
						paginationPageSize={6}
						defaultColDef={{
							filter: "agTextColumnFilter",
							floatingFilter: true,
							resizable: true
						}}
						enableCellChangeFlash={true}
						defaultColGroupDef={{ marryChildren: true }}
						frameworkComponents={{
							handleDetailsChangeRender: handleDetailsChangeRender,
							schema: customersFilterSchema,
							handleDateCellRenderer: handleDateCellRenderer,
							handleUserRoleCellRenderer: handleUserRoleCellRenderer,
							handleRegisteredcustomerCellRenderer: handleRegisteredcustomerCellRenderer,
							handleValueCellRenderer: handleValueCellRenderer,
							setPayloadSchema: setcustomersFilterSchema,
							setParentSchema: setGroupOwners,
							customFloatingFilter: CustomFloatingFilter,
							customFilter: CustomFilter
						}}
						rowSelection={"single"}
					>
						{/* {user &&
						user.role === ROLES.super_admin &&
						((user.first_name === "Sourish" && user.last_name === "Mukherjee") ||
							(user.first_name === "Anupam" && user.last_name === "Biswas") ||
							(user.first_name === "Rahul" && user.last_name === "Dutta") ||
							(user.first_name === "Suman" && user.last_name === "Dutta")) ? (
							<AgGridColumn
								field="group_number"
								headerName="Group Number"
								suppressSizeToFit
							></AgGridColumn>
						) : null} */}
						<AgGridColumn
							field="group_name"
							headerName="Group Name"
							suppressSizeToFit
							//floatingFilterComponentParams={{ suppressFilterButton: true }}
							floatingFilterComponent="customFloatingFilter"
							filter="customFilter"
							onCellClicked={handleViewcustomersDetails}
							cellStyle={() => {
								return { cursor: "pointer" };
							}}
						></AgGridColumn>
						<AgGridColumn
							field="store_name"
							headerName="Store Name"
							suppressSizeToFit
							//floatingFilterComponentParams={{ suppressFilterButton: true }}
							floatingFilterComponent="customFloatingFilter"
							filter="customFilter"
							onCellClicked={handleViewcustomersDetails}
							cellStyle={() => {
								return { cursor: "pointer" };
							}}
						></AgGridColumn>
						<AgGridColumn
							field="customer_id"
							headerName="Customer Id"
							suppressSizeToFit
							// checkboxSelection={true}
							//floatingFilterComponentParams={{ suppressFilterButton: true }}
							// cellRenderer="handleValueCellRenderer"
							// floatingFilterComponentParams={{
							// 	suppressFilterButton: true
							// }}
							floatingFilterComponent="customFloatingFilter"
							filter="customFilter"
							onCellClicked={handleViewcustomersDetails}
							cellStyle={() => {
								return { cursor: "pointer" };
							}}
						></AgGridColumn>
						<AgGridColumn
							field="first_name"
							headerName="First Name"
							suppressSizeToFit
							//floatingFilterComponentParams={{ suppressFilterButton: true }}
							floatingFilterComponent="customFloatingFilter"
							filter="customFilter"
							onCellClicked={handleViewcustomersDetails}
							cellStyle={() => {
								return { cursor: "pointer" };
							}}
						></AgGridColumn>
						<AgGridColumn
							field="last_name"
							headerName="Last Name"
							suppressSizeToFit
							//floatingFilterComponentParams={{ suppressFilterButton: true }}
							floatingFilterComponent="customFloatingFilter"
							filter="customFilter"
							onCellClicked={handleViewcustomersDetails}
							cellStyle={() => {
								return { cursor: "pointer" };
							}}
						></AgGridColumn>
						<AgGridColumn
							field="phone"
							headerName="Phone Number"
							suppressSizeToFit
							//floatingFilterComponentParams={{ suppressFilterButton: true }}
							floatingFilterComponent="customFloatingFilter"
							filter="customFilter"
							onCellClicked={handleViewcustomersDetails}
							cellStyle={() => {
								return { cursor: "pointer" };
							}}
						></AgGridColumn>
						<AgGridColumn
							field="age_range"
							headerName="Age Range"
							suppressSizeToFit
							//floatingFilterComponentParams={{ suppressFilterButton: true }}
							// cellRenderer="handleDateCellRenderer"
							filter={false}
						></AgGridColumn>
						<AgGridColumn
							field="gender"
							headerName="Gender"
							suppressSizeToFit
							//floatingFilterComponentParams={{ suppressFilterButton: true }}
							floatingFilterComponent="customFloatingFilter"
							filter="customFilter"
							// onCellClicked={handleViewcustomersDetails}
							cellStyle={() => {
								return { cursor: "pointer" };
							}}
						></AgGridColumn>
						<AgGridColumn
							field="action"
							headerName="Action"
							cellRenderer="handleDetailsChangeRender"
							filter={false}
							suppressSizeToFit={true}
						></AgGridColumn>
					</AgGridReact>
				</div>
			</div>
			<div className="custom-pagination" id="custom-pagination">
				<CustomPagination pageCount={pageCount} currentPage={currentPage} handlePageChange={handlePageChange} />
			</div>
		</div>
	);
};

export default GroupOwnersGrid;
